import { render, staticRenderFns } from "./safety-dialog.vue?vue&type=template&id=fef14f14&scoped=true&"
import script from "./safety-dialog.vue?vue&type=script&lang=js&"
export * from "./safety-dialog.vue?vue&type=script&lang=js&"
import style0 from "./safety-dialog.vue?vue&type=style&index=0&id=fef14f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef14f14",
  null
  
)

export default component.exports